import { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import Modal, { useModalState/*, useModal*/ } from 'react-simple-modal-provider';
import LinkExternal from '../components/Link/LinkExternal';



const AlertModal = ({ children }) => {
  const [isOpen, setOpen] = useModalState();
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [isOpen]);
  /*const onClose = () => {
    setOpen(false);
  }*/
  /*const [data, setData] = useState(null);
  const asyncOpen = async () => {
    try {
      await new Promise((r) => setTimeout(r, 1000));
      setData({});
    } catch (error) { console.error(error); }
  };*/
  // const { open: openTemplateModal } = useModal('TemplateModal');

  return (
    <Modal
      id={'AlertModal'}
      consumer={children}
      isOpen={isOpen}
      setOpen={setOpen}
      //asyncOpen={asyncOpen}
      draggable={false}
      duration={300}
      //animation={modalAnimation.scaleUp}
      width={350}
      height={370}
      radius={10}
      backgroundColor={'rgb(254, 92, 80)'}
    >
      <div style={{
        backgroundColor: '#fff',
        margin: '10px', padding: '10px', borderRadius: '6px', width: '350px',
        height: '370px', color: 'black',
        textAlign: 'center'
        ,
      }}>
        <div>
          <b>After learning about the rumors going on with the Migration Smart Contract from OpenSea, we will decide to proceed with the sale as it does not put you at risk.</b>
        </div>
        <br />
        <div>
          <b>Do not use OpenSea to sell any NFTs and use the tool below.</b>
          <b>Use the Etherscan tool to remove all 'Approval' from your addresses:</b>
          <br />
          <LinkExternal href='https://etherscan.io/tokenapprovalchecker' style={{ color: 'blue' }}>etherscan.io/tokenapprovalchecker</LinkExternal>
        </div>
      </div>
    </Modal>
  );
};

export default hot(module)(AlertModal);
